module.exports = __webpack_public_path__ + "img/40_18.d8be8502.png";